<!-- Bouton Retour Coordonnées -->
<dsd-link-action variant="return">
  <a [href]="urlCoordonnees"
    ><span class="dsd-sr-only">{{ 'caad.button.horsEcran.allerA' | translate }}&nbsp;</span
    >{{ 'caad.button.coordonnees' | translate }}</a
  >
</dsd-link-action>
